import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import {
  FaBed,
  FaEnvelope,
  FaFlask,
  FaHeartbeat,
  FaNotesMedical,
  FaPhoneAlt,
  FaPills,
  FaProcedures,
  FaStream,
  FaUserMd,
  FaUserNurse,
  FaXRay,
} from "react-icons/fa";
import { IoBedOutline } from "react-icons/io5";
import Vitals from "./vitals";
import Medication from "./Medication";
import MedicalHistory from "./MedicalHistory";
import Labs from "./Labs";
import Radiology from "./Radiology";
import Orders from "./Orders";
import Notes from "./Notes";
import ClinicalNotes from "./ClinicalNotes";
import IPDConsultation from "./IPDConsultation";
import { useParams } from "react-router-dom";
import PatientService from "../../../Services/PatientService";
import Discharge from "./Discharge";
import Timeline from "./TimeLine";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import Pharmacy from "./Pharmacy";

function InPatientsNew() {
  const loginObj = localStorage.getItem("login_result");
  const loggedUser = loginObj ? JSON.parse(loginObj) : null;
  const [activeTab, setActiveTab] = useState("vitals");
  const [patientDetails, setPatientDetails] = useState(null);
  const { id } = useParams();
  const location = useLocation();
  const admission = location.state?.admission;

  console.log("Patient ID:", id);
  console.log("Admission:", admission);
  console.log("id ", id);

  useEffect(() => {
    if (id) {
      getPatientDetails(id);
    }
  }, [id]);

  const getPatientDetails = async (patientId) => {
    try {
      const res = await PatientService.PatientListFilter({ patientId });
      console.log("res", res?.data?.[0]);
      setPatientDetails(res?.data?.[0]);
      sessionStorage.setItem("patient", JSON.stringify(res?.data?.[0]));
    } catch (e) {
      console.error(e);
    }
  };

  const tabs = [
    { name: "Vitals", key: "vitals", icon: <FaHeartbeat /> },
    {
      name: "Medical History",
      key: "medicalHistory",
      icon: <FaNotesMedical />,
    },
    { name: "Medication", key: "medication", icon: <FaPills /> },
    { name: "Clinical Notes", key: "clinicalNotes", icon: <FaNotesMedical /> },
    { name: "IPD-Consultation", key: "ipdConsultation", icon: <FaUserMd /> },
    { name: "Pharmacy", key: "pharmacy", icon: <FaPills /> },
    // { name: "Labs", key: "labReports", icon: <FaFlask /> },
    { name: "Lab", key: "radiology", icon: <FaXRay /> },
    { name: "Orders", key: "orders", icon: <FaProcedures /> },
    { name: "Doctor/Nurse Notes", key: "doctorNotes", icon: <FaUserMd /> },

    { name: "Timeline", key: "timeline", icon: <FaStream /> },
    { name: "Discharge Summary", key: "discharge", icon: <FaBed /> },
  ];

  return (
    <Layouts>
      <div className="flex gap-2">
        <div className="w-[100%]">
          <div className="bg-white border border-[#e9edf5] rounded-lg overflow-hidden">
            <div className="grid grid-cols-12">
              {/* LEFT */}
              <div className="col-span-5 flex items-center gap-4 border-r border-[#edf1f7] px-6 py-3">
                <img
                  src={
                    process.env.REACT_APP_IMAGE_URL + patientDetails?.photoName
                  }
                  alt={patientDetails?.firstName}
                  className="h-[75px] w-[75px] rounded-full border-[5px] border-[#dff7e8] object-cover"
                />

                <div className="flex-1 mb-2">
                  {/* Patient Name */}
                  <h1 className="text-lg font-bold font-sans leading-[42px] text-[#111827]">
                    {patientDetails?.firstName} {`(${admission?.gender})`}
                  </h1>

                  {/* Basic Details */}
                  <div className="flex items-center gap-5 text-xs font-bold font-sans text-[#4b5563]">
                    <span>Age: {admission?.age || "--"}</span>
                    <span>UHID: {patientDetails?.uhId}</span>
                    <span>Blood Group: {patientDetails?.bloodGroup}</span>
                  </div>

                  {/* Ward / Room / Bed */}
                  <div className="mt-4 flex items-center gap-2">
                    <IoBedOutline className="text-lg text-teal-500" />
                    <span className="text-xs font-sans text-gray-700">
                      <span className="font-semibold">
                        {admission?.wardName}
                      </span>
                      <span className="mx-1 text-gray-400">/</span>
                      {admission?.bedCode}
                      <span className="mx-1 text-gray-400">/</span>
                      <span className="font-semibold text-teal-600">
                        {admission?.bedNumber}
                      </span>
                    </span>
                  </div>

                  <div className="mt-5 flex items-center gap-8">
                    <div className="flex items-center gap-2 text-xs font-semibold font-sans text-[#374151]">
                      <FaPhoneAlt className="text-xs text-[#5b5bd6]" />
                      <span>{patientDetails?.mobile}</span>
                    </div>

                    <div className="flex items-center gap-2 text-xs font-semibold font-sans text-[#374151]">
                      <FaEnvelope className="text-xs text-[#5b5bd6]" />
                      <span>{patientDetails?.email}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT */}
              <div className="col-span-7 grid grid-cols-3">
                <div className="px-6 py-5 border-r border-[#edf1f7]">
                  <p className="text-[13px] text-[#6b7280]">IP Number</p>

                  <h2 className="text-sm font-sans font-bold text-[#10b981] mt-2">
                    {admission?.admissionNo}
                  </h2>

                  <p className="text-[13px] text-[#6b7280] mt-2">Department</p>

                  <h3 className="text-sm font-sans font-semibold mt-1">
                    {admission?.departmentId}
                  </h3>
                  <p className="text-xs font-sans font-semibold text-[#6b7280] mt-4">
                    Patient Status
                  </p>

                  <span className="inline-flex bg-[#dcfce7] text-[#16a34a] text-sm font-medium px-3 py-1 rounded-lg mt-2">
                    {"Stable"}
                  </span>
                </div>

                <div className="px-6 py-5 border-r border-[#edf1f7]">
                  <p className="text-xs font-sans font-semibold text-[#6b7280]">
                    Admission Date & Time
                  </p>

                  <h3 className="text-sm font-sans font-semibold mt-2">
                    {dayjs(admission?.admissionDate).format("DD-MM-YYYY hh:mm")}
                  </h3>

                  <p className="text-xs font-sans font-semibold text-[#6b7280] mt-2">
                    Treatment Doctor
                  </p>

                  <h3 className="text-sm font-sans font-semibold mt-1">
                    {admission?.userName}
                  </h3>
                  <div className="flex items-center gap-3 mt-3">
                    <div>
                      <p className="text-xs text-gray-500">Assigned Nurse</p>
                      <p className="text-sm font-semibold text-gray-800 mt-2">
                        {"--"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="px-6 py-5">
                  <div className="mt- flex flex-col gap-1">
                    <p className="text-xs text-gray-500 font-sans font-semibold">
                      Excepted Discharge Date
                    </p>
                    <h2 className="text-sm font-sans font-bold text-[#10b981]">
                      {dayjs(admission?.expectedDischargeDate).format(
                        "DD-MM-YYYY",
                      )}
                    </h2>
                  </div>
                  <div className="mt- flex flex-col gap-1">
                    <p className="text-xs text-gray-500 font-sans font-semibold">
                      Insurance
                    </p>
                    <h2 className="text-sm font-sans font-bold text-[#10b981]">
                      {"Star Health Insurance"}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white border border-[#e9edf5] mt-5 rounded-[22px] h-[58px] px-5 flex items-center gap-10 overflow-x-auto scrollHide">
            {tabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-2 h-full bg-white whitespace-nowrap text-[13px] transition-all duration-200 ${
                  activeTab === tab.key
                    ? "border-b-[2px] border-brand-primaryColor font-bold text-brand-primaryColor"
                    : "font-semibold"
                }`}
              >
                <span className="text-sm">{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </div>
          <div className="bg-white border border-[#e9edf5] mt-5 rounded-[22px] px-5  overflow-x-auto scrollHide">
            {activeTab == "vitals" && (
              <Vitals
                patientId={patientDetails?.patientId || id}
                accountId={patientDetails?.accountId}
                clinicId={patientDetails?.clinicId}
                admissionId={admission?.admissionId}
              />
            )}
            {activeTab == "medication" && (
              <Medication patientId={patientDetails?.patientId || id} />
            )}
            {activeTab == "clinicalNotes" && (
              <ClinicalNotes
                patientDetails={patientDetails}
                patientId={patientDetails?.patientId || id}
                admissionId={admission?.admissionId}
              />
            )}
            {activeTab == "ipdConsultation" && (
              <IPDConsultation
                patientDetails={patientDetails}
                patientId={patientDetails?.patientId || id}
                admissionId={admission?.admissionId}
                admission={admission}
              />
            )}
            {activeTab == "medicalHistory" && <MedicalHistory />}
            {activeTab == "pharmacy" && (
              <Pharmacy
                patientDetails={patientDetails}
                patientId={patientDetails?.patientId || id}
                admissionId={admission?.admissionId}
              />
            )}
            {activeTab == "radiology" && (
              <Radiology
                patientDetails={patientDetails}
                patientId={patientDetails?.patientId || id}
                admissionId={admission?.admissionId}
              />
            )}
            {activeTab == "orders" && (
              <Orders
                patientDetails={patientDetails}
                patientId={patientDetails?.patientId || id}
                admission={admission}
                admissionId={admission?.admissionId}
              />
            )}
            {activeTab == "doctorNotes" && (
              <Notes
                patientDetails={patientDetails}
                patientId={patientDetails?.patientId || id}
                admissionId={admission?.admissionId}
              />
            )}
            {activeTab == "timeline" && (
              <div className="py-5">
                <Timeline
                  patientDetails={patientDetails}
                  patientId={patientDetails?.patientId || id}
                  admissionId={admission?.admissionId}
                  admission={admission}
                />
              </div>
            )}
            {activeTab == "discharge" && (
              <Discharge
                patientDetails={patientDetails}
                patientId={patientDetails?.patientId || id}
                admissionId={admission?.admissionId}
                admission={admission}
              />
            )}
          </div>
        </div>
      </div>
    </Layouts>
  );
}

export default InPatientsNew;
